import React from "react";
import { Utensils, Droplets, Moon, Trophy, Salad, Clock } from "lucide-react";

export default function WeeklyTips({ targets, raceWeek, profile, goal }) {
  const days = targets?.daily || [];
  if (!days.length) return null;
  const wt = Number(profile?.weight) || 0;
  const proteinPerKg = wt && targets.weekAverage?.protein ? (targets.weekAverage.protein / wt).toFixed(1) : null;

  const tips = [
    { icon: Clock, title: "Time your carbs", color: "#34C759",
      text: "Eat most of your carbs in the 3–4 h before and the 60 min after your hardest sessions — that's when muscles store them best." },
    { icon: Utensils, title: "Protein at every meal", color: "#4C9AFF",
      text: `Spread ${proteinPerKg ? `~${proteinPerKg} g/kg` : "your protein"} across 3–4 meals (~0.3 g/kg each) rather than one big hit — it maximises muscle repair.` },
    { icon: Droplets, title: "Hydrate ahead", color: "#4C9AFF",
      text: "Sip fluids through the day, not just around training. Add electrolytes on hot or long sessions and weigh in before/after to gauge sweat loss." },
    { icon: Moon, title: "Respect easy days", color: "#A1A1AA",
      text: "Lower-carb rest days are intentional. Lean on protein, veg and healthy fats — you don't need race fuel to sit on the sofa." },
    { icon: Salad, title: "Whole foods first", color: "#34C759",
      text: "Save gels and drinks for training; build everyday meals from whole carbs, lean protein and colourful veg for micronutrients and fibre." },
  ];
  if (goal === "fat-loss") tips.push({ icon: Utensils, title: "Protect the deficit", color: "#FF9500",
    text: "Keep the deficit on easy and rest days and fuel key sessions fully — under-fuelling hard days tanks performance and recovery." });
  if (raceWeek?.enabled) tips.push({ icon: Trophy, title: "Rehearse race fuelling", color: "#FF3B30",
    text: `Practise ${raceWeek.carbsPerHour} g carbs/hr in training before race day — never trial new products or amounts for the first time on the day.` });

  return (
    <div className="mb-8" data-testid="weekly-tips">
      <div className="grid sm:grid-cols-2 gap-3">
        {tips.map((t, i) => {
          const Icon = t.icon;
          return (
            <div key={i} data-testid={`tip-${i}`} className="flex items-start gap-3 border border-white/10 bg-[#141414] p-4 print-day">
              <span className="grid place-items-center h-8 w-8 shrink-0 border" style={{ borderColor: `${t.color}66`, color: t.color }}>
                <Icon className="h-4 w-4" />
              </span>
              <div>
                <p className="text-sm text-white font-semibold mb-1">{t.title}</p>
                <p className="text-[13px] text-zinc-200 leading-relaxed">{t.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
